import React, { useState} from 'react';
import { Button, Icon } from '@salesforce/design-system-react';

const MilestoneConnectors = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="slds-p-vertical_small slds-p-left_small" style={{ borderLeft: '1px dashed #014486' }}>
            <div className="slds-grid">
                <div 
                    className="slds-size_1-of-5 slds-align_absolute-center"
                    style={{ color: 'white', backgroundColor: '#3290ED'}}
                >{Object.keys(props.connectors).length}</div>
                <div 
                    onClick={isOpen ? () => setIsOpen(false) : () => setIsOpen(true)}
                    className="slds-size_4-of-5 slds-p-left_xx-small" 
                    style={{ color: "#3290ED", cursor: "pointer"}}
                >{isOpen ? 'Connectors -' : 'Connectors +'}</div>
            </div>

            
            {isOpen ? Object.keys(props.connectors).map((id) => {
                return (
                    <div className="slds-grid slds-p-top_xx-small">
                        <div 
                            className="slds-p-around_xx-small" 
                        >
                            <div style={{ color: "#3290ED", fontWeight: '600'}}><a href="MilestoneConnectors">{props.connectors[id].title}</a></div>
                            <div style={{ color: "#3290ED"}}>{props.connectors[id].content}</div>
                        </div>
                    </div>
                )}
            ) : null}
        </div>
    );
}

export default MilestoneConnectors;
